import { RefreshCw, Sparkles } from "lucide-react";
import type { NarrativeData } from "../../types/status";

export default function NarrativeCard({
  narrative,
  loading,
  onDrillDown,
}: {
  narrative: NarrativeData | null;
  loading: boolean;
  onDrillDown: () => void;
}) {
  if (loading) {
    return (
      <div className="mb-6 flex items-center gap-2.5 rounded-2xl bg-[#1D345F] px-6 py-5">
        <RefreshCw size={14} className="animate-spin shrink-0 text-white/50" />
        <span className="text-sm text-white/60">Reading the week…</span>
      </div>
    );
  }

  if (!narrative) return null;

  const hasIncidents = narrative.incident_ids.length > 0;

  return (
    <button
      onClick={hasIncidents ? onDrillDown : undefined}
      disabled={!hasIncidents}
      className={`mb-6 w-full rounded-2xl bg-[#1D345F] px-6 py-5 text-left transition-colors focus:outline-none focus:ring-2 focus:ring-blue-300 ${
        hasIncidents ? "cursor-pointer hover:bg-[#24406f]" : "cursor-default"
      }`}
    >
      <div className="flex items-start gap-4">
        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/10">
          <Sparkles size={16} className="text-white" aria-hidden="true" />
        </span>
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wider text-blue-200/70">
            Brian&apos;s read on the week
          </p>
          <p className="mt-1.5 text-sm leading-relaxed text-white/90">{narrative.narrative}</p>
          {hasIncidents && (
            <span className="mt-3 inline-block text-sm font-medium text-blue-200 underline underline-offset-2">
              See the incidents behind this →
            </span>
          )}
        </div>
      </div>
    </button>
  );
}
